import React from 'react';
import {
  Box,
  Button,
  LabIconsAddArtIcon,
  LabIconsAddTextIcon,
  LabIconsUploadIcon,
  Stack
} from '@customink/pigment-react';
import {useSelector} from 'react-redux';
import {isAddToClipartEnabled as isAddToClipartEnabledSelector} from '~/selectors/ConfigSelectors';

import UploadButton from '~/components/UploadButton';
import {useNavigate} from 'react-router-dom';
import {metrics} from '~/vendor/metrics';

const ElevateMobileUpload = function () {
  const navigate = useNavigate();
  const isAddToClipartEnabled = useSelector(isAddToClipartEnabledSelector);
  const addText = () => {
    metrics.fireEvent({
      event: 'lab_text_start',
      source: 'blank canvas options'
    });
    window.dataLayer?.push({
      event: 'lab_text_start',
      source: 'blank canvas options'
    });
    navigate('/addText');
  };

  const addArt = () => {
    metrics.fireEvent({
      event: 'lab_art_start',
      art_source: 'blank canvas options'
    });
    window.dataLayer?.push({
      event: 'lab_art_start',
      art_source: 'blank canvas options'
    });
    navigate('/addArt');
  };

  return (
    <Box
      display="flex"
      color="white"
      alignItems="center"
      top="3.75rem"
      bottom="4rem"
      width="100%"
      position="absolute"
      data-testid="elevate-mobile-upload"
      className="ndx-ElevateMobileUpload"
      sx={{pointerEvents: 'none'}}>
      <Stack
        sx={{
          display: 'flex',
          width: '190px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '12px',
          margin: 'auto',
          pointerEvents: 'auto'
        }}
        spacing="lg">
        <Box width="100%">
          <UploadButton mobileUpload>
            <Button
              fullWidth
              startIcon={<LabIconsUploadIcon />}
              variant="primary"
              size="large">
              Upload
            </Button>
          </UploadButton>
        </Box>
        <Button
          fullWidth
          startIcon={<LabIconsAddTextIcon />}
          variant="secondary"
          size="large"
          onClick={addText}>
          Add Text
        </Button>
        <Button
          fullWidth
          startIcon={<LabIconsAddArtIcon />}
          variant="secondary"
          size="large"
          onClick={addArt}>
          {isAddToClipartEnabled ? 'Add Clipart' : 'Add Art'}
        </Button>
      </Stack>
    </Box>
  );
};

ElevateMobileUpload.displayName = 'ElevateMobileUpload';

export default ElevateMobileUpload;
